import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';

import { FxFlexDirective } from '../flex-layout';

@Component({
  selector: 'rspl-active-inactive-toggle',
  templateUrl: './active-inactive-toggle.component.html',
  styleUrls: ['./active-inactive-toggle.component.scss'],
  imports: [MatButtonToggleGroup, MatButtonToggle, FxFlexDirective],
})
export class ActiveInactiveToggleComponent {
  @Input() inactive = false;
  @Input() disabled = false;
  @Input() activeLabel = 'Active';
  @Input() inactiveLabel = 'Inactive';
  @Output() inactiveChange = new EventEmitter<boolean>();

  setInactive(value: boolean): void {
    if (this.disabled || this.inactive === value) return;
    this.inactive = value;
    this.inactiveChange.emit(value);
  }
}
